import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=bc667344"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc667344')) {
      api.createRecord('bc667344', component.options)
    } else {
      api.reload('bc667344', component.options)
    }
    module.hot.accept("./Pago.vue?vue&type=template&id=bc667344", function () {
      api.rerender('bc667344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/Pago.vue"
export default component.exports